import React from 'react';
import PropTypes from 'prop-types';

import { Icon, Loader } from '@weezevent/nacre';
import Styles from '../../../styles/minisite/blocks.module.css';
import { Trans } from 'react-i18next';

export default function DateBlock({ onClick }) {
    const [isLoading, setIsLoading] = React.useState(false);

    const handleClick = React.useCallback(() => {
        setIsLoading(true);
        onClick();
    }, [onClick]);

    return (
        <div className={`${Styles['create-content']} ${isLoading ? Styles['disabled-create-content'] : ''}`} onClick={handleClick}>
            {isLoading && <Loader inline />}
            <Icon name="calendar" />
            <Trans i18nKey="ticket.event.minisite.block.add-block-date" />
        </div>
    );
}

DateBlock.propTypes = {
    onClick: PropTypes.func.isRequired
};
